import React from "react";
import { RCCAccordion } from "react-common-components";
import IComponentAccordion from "react-common-components/dist/components/Accordion/interface";
import Container from "./styles";

const AccordionList: React.FC<IComponentAccordion> = ({
	children,
	header,
	...rest
}) => (
	<RCCAccordion
		header={
			<Container>
				{header}
			</Container>
		}
		styleInline={{
			header:"background:var(--accordion-color); border: 1px solid var(--border-color);"
		}}
		{...rest}
		className="rccaccordion-groupers"
	>
		{typeof children !== "undefined" && children !== null && 
            <> {children} </>
		}
	</RCCAccordion>
);

export default AccordionList;
